import $ from 'jquery';

(function () {
    'use strict';

    squiz.fn.feedbackVote = function (rating, pageID) {
        var selected, unselected, ratingParam, success = $('.js-feedback-utility-success');
        if (rating) {
            selected = $('.feedback__button--up');
            unselected = $('.feedback__button--down');
            ratingParam = '&rating_up=1';
        } else {
            selected = $('.feedback__button--down');
            unselected = $('.feedback__button--up');
            ratingParam = '&rating_down=1';
        }

        selected.addClass('active');
        unselected.addClass('disabled');
        unselected.attr('disabled', 'disabled');
        selected.attr('disabled', 'disabled');
        selected.find('.feedback-button__icon.loader').removeClass('hidden');
        selected.find('.feedback-button__icon.default').addClass('hidden');
        var url = $('.feedback').attr('data-submit') + '?SQ_ASSET_CONTENTS_RAW&page_id=' + pageID + ratingParam;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.onload = function () {
            if (this.readyState == 4 && this.status == 200) {
                selected.find('.feedback-button__icon.loader').addClass('hidden');
                selected.find('.feedback-button__icon.done').removeClass('hidden');
                success.text("Thank you for your feedback.");
            } else {
                $(".feedback").append('<div class="feedback--error">Something went wrong. Please refresh the page and try again.</div>');
                success.text("Something went wrong. Please refresh the page and try again.");
            }
        };
        xhr.send();
    };

    $('.feedback__button--more, .feedback-form__cancel').on('click', function () {
        if ($('.feedback-form').css('display') == 'none') {
            $('.feedback__button--more').addClass('opened');
        } else {
            $('.feedback__button--more').removeClass('opened');
        }
        $('.feedback-form').slideToggle();
    });

    $('.feedback__button--down').on('click', function () {
        squiz.fn.feedbackVote(false, $('.feedback').attr('data-pageid'));
    });

    $('.feedback__button--up').on('click', function () {
        squiz.fn.feedbackVote(true, $('.feedback').attr('data-pageid'));
    });

}());

